import React, { ReactNode } from 'react';

import { getActivePublisherDetails } from 'state/publishers/selectors/publishersSelectors';

import { useExternalUpdatePublisherMutation } from '../hooks/useUpdatePublisherMutation';

import { useUpdateUserPropertiesMutation } from 'gql/hooks/useUpdateUserPropertiesMutation';
import { intlConnect } from 'utils/connectUtils';

import { State as RootState } from 'types/rootState';

type OwnProps = {
  children: ReactNode;
};

type StateProps = ReturnType<typeof mapStateToProps>;

type Props = OwnProps & StateProps;

export const mapStateToProps = (state: RootState) => {
  const activePublisher = getActivePublisherDetails(state);
  const bizProfileId = activePublisher?.businessProfileId;
  const publisherId = activePublisher?.id;
  return {
    activePublisher,
    bizProfileId,
    publisherId,
  };
};

export default function withExternalUserUpdatePublisherMutation(Component: typeof React.Component) {
  function WrappedComponent(props: Props) {
    const { updatePublisher, data, error } = useExternalUpdatePublisherMutation();
    const { updateUserProperties } = useUpdateUserPropertiesMutation();

    return (
      <Component
        {...props}
        updatePublisher={updatePublisher}
        updatePublisherData={data}
        updatePublisherError={error}
        updateUserProperties={updateUserProperties}
        data-test={'withUpdatePublisherMutation.component'}
      >
        {props.children}
      </Component>
    );
  }

  return intlConnect(mapStateToProps, null)(WrappedComponent);
}
